import { render, staticRenderFns } from "./SenderBubble.vue?vue&type=template&id=b554ac54&scoped=true"
import script from "./SenderBubble.vue?vue&type=script&lang=js"
export * from "./SenderBubble.vue?vue&type=script&lang=js"
import style0 from "./SenderBubble.vue?vue&type=style&index=0&id=b554ac54&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b554ac54",
  null
  
)

export default component.exports